import isPlainObject from "lodash/fp/isPlainObject";

export default function isMergeableObject(value) {
  return isPlainObject(value) && !value.$$typeof;
}
